import {
  TeacherAssignmentStudentGradesDocument,
  TeacherAssignmentStudentGradesQuery,
  TeacherAssignmentStudentGradesQueryVariables,
  TeacherGradeInsertDocument,
  TeacherGradeInsertMutation,
  TeacherGradeInsertMutationVariables,
  TeacherGradeUpdateMarkDocument,
  TeacherGradeUpdateMarkMutation,
  TeacherGradeUpdateMarkMutationVariables,
  TeacherStudentGradesBySemesterQueryVariables,
  TeacherStudentGradesBySemesterQuery,
  TeacherStudentGradesBySemesterDocument,
  TeacherStudentGradesSemesterFragment,
} from '../types';
import { client } from '../../client';
import { SemesterGradesFragment, YearGradesFragment } from '../../student_parent/repositories/gradeRepository';
import { getCurrentYear } from '../../shared/repositories/yearRepository';

// [Teacher] Insert a grade to an assignment
export async function teacherInsertGrades(variables: TeacherGradeInsertMutationVariables): Promise<Readonly<any>> {
  try {
    var result = await client.mutate<TeacherGradeInsertMutation, TeacherGradeInsertMutationVariables>({
      mutation: TeacherGradeInsertDocument,
      variables,
    });
    return result.data.insert_grades.returning;
  } catch (error) {
    throw Error(error);
  }
}

// teacherAssignmentGradesQuery
export async function teacherGetAssignmentGrades(variables: TeacherAssignmentStudentGradesQueryVariables): Promise<Readonly<any>> {
  try {
    var result = await client.query<TeacherAssignmentStudentGradesQuery, TeacherAssignmentStudentGradesQueryVariables>({
      query: TeacherAssignmentStudentGradesDocument,
      variables,
      fetchPolicy: 'network-only',
    });
    return result.data.assigment_student_grade;
  } catch (error) {
    throw Error(error);
  }
}

// [Teacher] Update the grade mark
export async function teacherUpdateGradeMark(variables: TeacherGradeUpdateMarkMutationVariables): Promise<Readonly<string>> {
  try {
    var result = await client.mutate<TeacherGradeUpdateMarkMutation, TeacherGradeUpdateMarkMutationVariables>({
      mutation: TeacherGradeUpdateMarkDocument,
      variables,
    });
    return result.data.update_grades_by_pk.id;
  } catch (error) {
    throw Error(error);
  }
}

// [StudentOrParent] Get grades by semester
// Helper function
async function studentGetSemesterGrades(
  variables: TeacherStudentGradesBySemesterQueryVariables,
): Promise<Array<TeacherStudentGradesSemesterFragment>> {
  try {
    const result = await client.query<TeacherStudentGradesBySemesterQuery, TeacherStudentGradesBySemesterQueryVariables>({
      query: TeacherStudentGradesBySemesterDocument,
      variables,
    });
    return result.data.subjects;
  } catch (error) {
    throw Error(error);
  }
}
